var map = {
	"./1.png": 5996,
	"./10.png": 2198,
	"./11.png": 1215,
	"./12.png": 6724,
	"./13.png": 9757,
	"./14.png": 5506,
	"./15.png": 6635,
	"./2.png": 6631,
	"./3.png": 7262,
	"./4.png": 9729,
	"./5.png": 5112,
	"./6.png": 9603,
	"./7.png": 746,
	"./8.png": 4813,
	"./9.png": 3684,
	"./ant.png": 2782,
	"./aquarium.png": 2088,
	"./badger.png": 7892,
	"./bat.png": 2520,
	"./bear.png": 3439,
	"./beaver.png": 5598,
	"./bee.png": 5421,
	"./bird.png": 7280,
	"./bug.png": 9423,
	"./bull.png": 2570,
	"./bumblebee.png": 8668,
	"./butterfly.png": 632,
	"./cat.png": 8261,
	"./cat_footprint.png": 6321,
	"./caterpillar.png": 8464,
	"./chicken.png": 5072,
	"./clownfish.png": 8896,
	"./corgi.png": 497,
	"./cow.png": 8364,
	"./crab.png": 7283,
	"./deer.png": 4661,
	"./dinosaur.png": 7424,
	"./dog park.png": 8255,
	"./dog.png": 9767,
	"./dolphin.png": 8657,
	"./dragonfly.png": 2353,
	"./duck.png": 6294,
	"./elephant.png": 9038,
	"./falcon.png": 6026,
	"./fish food.png": 2148,
	"./fish.png": 4571,
	"./fly.png": 246,
	"./frog.png": 2191,
	"./giraffe.png": 2678,
	"./gorilla.png": 4203,
	"./grasshopper.png": 6621,
	"./hornet hive.png": 875,
	"./hornet.png": 3989,
	"./horse.png": 3722,
	"./hummingbird.png": 2617,
	"./icons8 logo.png": 3630,
	"./insect.png": 2521,
	"./kangaroo.png": 1527,
	"./kiwi.png": 8301,
	"./ladybird.png": 2448,
	"./leopard.png": 6570,
	"./lion.png": 6091,
	"./llama.png": 9237,
	"./mite.png": 5346,
	"./mosquito.png": 9416,
	"./octopus.png": 4994,
	"./panda.png": 5497,
	"./pig with lipstick.png": 1000,
	"./pig.png": 8157,
	"./prawn.png": 6345,
	"./puffin.png": 4913,
	"./rabbit.png": 9869,
	"./rhinoceros.png": 1595,
	"./seahorse.png": 3633,
	"./shark.png": 4946,
	"./sheep.png": 9572,
	"./snail.png": 6082,
	"./spider.png": 3750,
	"./starfish.png": 8211,
	"./stork.png": 5763,
	"./tentacles.png": 2348,
	"./turtle.png": 8479,
	"./unicorn.png": 3969,
	"./wasp.png": 1684,
	"./whale.png": 253,
	"./wolf.png": 1253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8770;